import useAudioStore from '../audio.store.tsx'
import useUiStore from '../ui.store.tsx'
import useTracksStore from '../tracks.store.tsx'

export const movePlaybackLineToClick = (e: React.MouseEvent): void => {
  useAudioStore.getState().stopPlayback()
  const pixelsPerSecond = useUiStore.getState().pixelsPerSecond
  const setPlaybackTime = useTracksStore.getState().setPlaybackTime
  const rect = e.currentTarget.getBoundingClientRect()
  const relativeX = e.clientX - rect.left
  setPlaybackTime(relativeX / pixelsPerSecond)
}
